import React from 'react';

import DerivativeDashboardProvider from 'views/derivatives/dashboard/DerivativeDashboard.provider';

import { FuturePositionAddTPSLPopup, FuturePositionAddTPSLPopupProps } from './FuturePositionAddTPSL.component';

export const FuturePositionAddTPSLPopupContainer: React.FC<
  React.PropsWithChildren<FuturePositionAddTPSLPopupProps>
> = ({ position, update }) => {
  const [base, quoted] = String(position.tradingPairCode).split('-');

  if (!position.tradingPairCode) return null;

  return (
    <DerivativeDashboardProvider base={base} quoted={quoted} code={position.tradingPairCode}>
      <FuturePositionAddTPSLPopup position={position} update={update} />
    </DerivativeDashboardProvider>
  );
};
